<template>
  <div class="hold-transition register-page" style="height: 100%;">
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      shading-color="rgba(0,0,0,0.4)"
    />
    <div v-if="showUploadProgress || showDownloadProgress" class="cc-progress-overlay">
      <div class="cc-progress-card">
        <p class="cc-progress-label">
          {{ showUploadProgress ? 'Subiendo archivo' : 'Descargando archivo' }}...
          <strong>{{ showUploadProgress ? uploadProgress : downloadProgress }}%</strong>
        </p>
        <div class="cc-progress-track">
          <div class="cc-progress-fill" :style="{ width: (showUploadProgress ? uploadProgress : downloadProgress) + '%' }"></div>
        </div>
      </div>
    </div>
    <div class="register-box" style="margin-top: 20px;width: 90%; min-width:900px !important;">
      <div class="register-logo">
        <!--<img src="http://arendal.com.mx/wp-content/uploads/2018/06/logo13.png" alt="Arendal" />-->
        <img src="@/assets/logoArendal.png" alt="Arendal" />
      </div>
      <section class="content container-fluid">
        <div class="box">
          <div class="form-horizontal" v-if="EstatusOverflow==5">
            <div style="padding: 10px;background: #55afff;color: #ffffff;">
              <span v-if=disabledAll>{{LangSelected.Externo.RegistroProveedor.TituloRegistrado}}</span>
              <span v-else>{{LangSelected.Externo.RegistroProveedor.Titulo}}</span>
            </div>
            <div class="box-body" v-if=disabledAll>
              <div class="row">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <p style="font-size: 1rem; font-weight: 400; line-height: 1.5;">{{LangSelected.Externo.RegistroProveedor.msgTituloRegistrado}}</p>
                </div>
              </div>
            </div>
            <div class="box-body" v-else>
              <div class="row">
                <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                  <div class="col-sm-4">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.PaisOrigen}}</span>
                  </div>
                  <div class="col-sm-8">
                    <div class="value">
                      <DxSelectBox
                        :search-enabled="true"
                        :search-mode="searchModeOption"
                        :search-expr="searchExprOption"
                        :data-source="JSONPais"
                        value-expr="Id_Pais"
                        display-expr="Pais"
                        :disabled="true"
                        :value="selPais"
                        @valueChanged="changePais"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                  <div class="col-sm-4">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.RFCTAX}}</span>
                  </div>
                  <div class="col-sm-8">
                    <div class="value">
                      <DxTextBox
                        v-model="selRFC"
                        placeholder="RFC"
                        :max-length="50"
                        :disabled=disabledAll
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <div class="col-sm-2">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.NomComercial}}</span>
                  </div>
                  <div class="col-sm-10" style="padding-left: 10px;">
                    <div class="value">
                      <DxTextBox
                        v-model="selComercial"
                        :placeholder="LangSelected.Externo.RegistroProveedor.NomComercialHint"
                        :max-length="255"
                        :disabled=disabledAll
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <div class="col-sm-2">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.RazonSocial}}</span>
                  </div>
                  <div class="col-sm-10" style="padding-left: 10px;">
                    <div class="value">
                      <DxTextBox
                        v-model="selRazonSocial"
                        :placeholder="LangSelected.Externo.RegistroProveedor.RazonSocial"
                        :max-length="255"
                        :disabled=disabledAll
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <div class="col-sm-2">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.TipoEmpresa}}</span>
                  </div>
                  <div class="col-sm-10">
                    <div class="value">
                      <DxRadioGroup
                        :items="TipoEmpresaEntities"
                        value-expr="id"
                        display-expr="text"
                        layout="horizontal"
                        style="padding-top:10px; font-size:10px"
                        :value="TipoEmpresa"
                        :disabled=disabledAll
                        @valueChanged="changeTipoEmpresa"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-md-4 col-xs-12 col-lg-4" style="margin-bottom: 0px;">
                  <div class="col-sm-7">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.DiasPlazo}}</span>
                  </div>
                  <div class="col-sm-5" style="padding-left: 0px;">
                    <div class="value">
                      <DxTextBox
                        v-model="selDias"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-8 col-xs-12 col-lg-8" style="margin-bottom: 0px;">
                  <div class="col-sm-4">
                    <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.ContactoArendal}}</span>
                  </div>
                  <div class="col-sm-8">
                    <div class="value">
                      <DxTextBox
                        v-model="selId_GrupoCompras"
                        :disabled="true"
                        :placeholder="LangSelected.Externo.RegistroProveedor.ContactoArendalHint"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 10px;">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <div class="col-sm-12">
                    <div>
                      <b-tabs v-model="tabIndex" content-class="mt-3" fill>
                        <b-tab active :disabled=disabledAll>
                          <template #title>
                            <span>{{LangSelected.Externo.RegistroProveedor.tabDocumentacion}} 
                              <b-icon v-if="doc_status==2" icon="check" variant="success"></b-icon>
                              <b-icon v-else-if="doc_status==1" icon="exclamation" variant="warning"></b-icon>
                              <b-icon v-else-if="doc_status==0" icon="x" variant="danger"></b-icon>
                            </span>
                          </template>
                          <DxDataGrid
                            id="gridDocumentacion"
                            :ref="gridDocumentacion"
                            :data-source="JSONDocumentos"
                            :allow-column-reordering="true"
                            :allow-column-resizing="true"
                            :column-auto-width="true"
                            :show-borders="true"
                            key-expr="Id_ProveedorSolicitudDocumentacion"
                          >
                            <DxColumnChooser :enabled="false"/>
                            <DxColumnFixing :enabled="true"/>
                            <DxFilterRow :visible="true"/>
                            <DxPaging :page-size="13"/>
                            <DxPager
                              :show-page-size-selector="true"
                              :allowed-page-sizes="[]"
                            />
                            <DxColumn 
                              :caption="LangSelected.Externo.RegistroProveedor.tbDocumento"
                              data-field="Documento"
                              alignment="left"
                              :allow-editing="false"
                              cell-template="cellTemplateDoc"
                            />
                            <DxColumn 
                              :caption="LangSelected.Externo.RegistroProveedor.tbDescripcion"
                              data-field="Descripcion"
                              alignment="left"
                              :allow-editing="false"
                              cell-template="cellTemplateDesc"
                            />
                            <DxColumn
                              :caption="LangSelected.Externo.RegistroProveedor.tbArchivo"
                              data-field="NombreDocumento"
                              alignment="center"
                              :width="220"
                              :allow-filtering="false"
                              cell-template="cellTemplateArch"
                            />
                            <template #cellTemplateDoc={data}>
                              <span class="color-upladed" v-if="data.data.NombreDocumento">{{data.data.Documento}}</span>
                              <span v-else>{{data.data.Documento}}</span>
                            </template>
                            <template #cellTemplateDesc={data}>
                              <span class="color-upladed" v-if="data.data.NombreDocumento" v-html="data.data.Descripcion" @click="findFunction(data.data.Descripcion)"></span>
                              <span v-else v-html="data.data.Descripcion" @click="findFunction(data.data.Descripcion)"></span>
                            </template>
                            <template #cellTemplateArch={data}>
                              <div v-if="data.data.NombreDocumento" style="margin: 2px auto;" @click="upFile(data)" v-b-modal.modal-2>
                                <p class="button-p-subir">{{data.data.NombreDocumento}}</p>
                                <span class="button-span-subir button-span-uploaded" :title=data.data.NombreDocumento>Reemplazar</span>
                              </div>
                              <span class="button-span-subir" v-else @click="upFile(data)" v-b-modal.modal-2>{{LangSelected.Externo.RegistroProveedor.tbSubir}}</span>
                            </template>
                          </DxDataGrid>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin: 5px auto;text-align: right;">
                              <!--<span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="tabIndex++">SIGUIENTE</span>-->
                              <span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="guardarTabs()" v-show="disabledAll==false" :disabled=disabledAll>{{LangSelected.Externo.RegistroProveedor.BtnGuardarEnviar}}</span>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab>
                          <template #title>
                            <span>{{LangSelected.Externo.RegistroProveedor.tabDireccion}}  
                              <b-icon v-if="selCalle && selColonia && selCP && selCiudad && selEstado" icon="check" variant="success"></b-icon>
                              <b-icon v-else-if="!selCalle && !selColonia && !selCP && !selCiudad && !selEstado" icon="x" variant="danger"></b-icon>
                              <b-icon v-else icon="exclamation" variant="warning"></b-icon>
                            </span>
                          </template>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                              <div class="col-sm-2">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.CalleNumero}}</span>
                              </div>
                              <div class="col-sm-10" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selCalle"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.CalleNumeroHint"
                                    :max-length="255"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-8 col-md-8 col-xs-8 col-lg-8" style="margin-bottom: 0px;">
                              <div class="col-sm-3">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Colonia}}</span>
                              </div>
                              <div class="col-sm-9" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selColonia"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.ColoniaHint"
                                    :max-length="255"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-sm-4 col-md-4 col-xs-4 col-lg-4" style="margin-bottom: 0px;">
                              <div class="col-sm-3">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.CP}}</span>
                              </div>
                              <div class="col-sm-9" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selCP"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.CPHint"
                                    :max-length="10"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Ciudad}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selCiudad"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.CiudadHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Estado}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selEstado"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.EstadoHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin: 5px auto;text-align: right;">
                              <!--<span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="tabIndex++">SIGUIENTE</span>-->
                              <span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="guardarTabs()" v-show="disabledAll==false" :disabled=disabledAll>{{LangSelected.Externo.RegistroProveedor.BtnGuardarEnviar}}</span>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab>
                          <template #title>
                            <span>{{LangSelected.Externo.RegistroProveedor.tabDatosContacto}}  
                              <b-icon v-if="selNombres && selApellidos && selApellidosM && selPuesto && selCorreo && selTelefono && selDireccion" icon="check" variant="success"></b-icon>
                              <b-icon v-else-if="!selNombres && !selApellidos && !selApellidosM && !selPuesto && !selCorreo && !selTelefono && !selDireccion" icon="x" variant="danger"></b-icon>
                              <b-icon v-else icon="exclamation" variant="warning"></b-icon>
                            </span>
                          </template>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                              <div class="col-sm-2">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Nombres}}</span>
                              </div>
                              <div class="col-sm-4" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selNombres"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.NombresHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                              <div class="col-sm-3" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selApellidos"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.PaternoHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                              <div class="col-sm-3" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selApellidosM"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.MaternoHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                              <div class="col-sm-2">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Puesto}}</span>
                              </div>
                              <div class="col-sm-10" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selPuesto"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.PuestoHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Correo}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    :disabled="true"
                                    v-model="selCorreo"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.CorreoHint"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Telefono}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selTelefono"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.TelefonoHint"
                                    :max-length="50"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                              <div class="col-sm-2">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Direccion}}</span>
                              </div>
                              <div class="col-sm-10" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selDireccion"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.DireccionHint"
                                    :max-length="255"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin: 5px auto;text-align: right;">
                              <!--<span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="tabIndex++">SIGUIENTE</span>-->
                              <span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="guardarTabs()" v-show="disabledAll==false" :disabled=disabledAll>{{LangSelected.Externo.RegistroProveedor.BtnGuardarEnviar}}</span>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab>
                          <template #title>
                            <span>{{LangSelected.Externo.RegistroProveedor.tabCuentaBancaria}}
                              <b-icon v-if="selMoneda && selBanco && selNumeroCuenta && selTitularCuenta && selABA && selSwiftCode" icon="check" variant="success"></b-icon>
                              <b-icon v-else-if="!selMoneda && !selBanco && !selNumeroCuenta && !selTitularCuenta && !selABA && !selSwiftCode" icon="x" variant="danger"></b-icon>
                              <b-icon v-else icon="exclamation" variant="warning"></b-icon>
                            </span>
                          </template>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Moneda}}</span>
                              </div>
                              <div class="col-sm-8" style="padding-left: 15px;">
                                <div class="value">
                                  <DxSelectBox
                                    :search-enabled="true"
                                    :search-mode="searchModeOptionMon"
                                    :search-expr="searchExprOptionMon"
                                    :data-source="JSONMonedas"
                                    value-expr="Id_Moneda"
                                    display-expr="Moneda"
                                    :disabled=disabledAll
                                    :value="selMoneda"
                                    @valueChanged="changeMoneda"
                                  />
                                </div>
                                <!--<div class="value">
                                  <DxTextBox
                                    v-model="selMoneda"
                                    placeholder="MXN"
                                    :disabled=disabledAll
                                  />
                                </div>-->
                              </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Banco}}</span>
                              </div>
                              <div class="col-sm-8" style="padding-left: 15px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selBanco"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.BancoHint"
                                    :max-length="100"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.NumCuenta}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selNumeroCuenta"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.NumCuentaHint"
                                    :max-length="50"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Titular}}</span>
                              </div>
                              <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 10px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selTitularCuenta"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.TitularHint"
                                    :max-length="255"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.ABA}}</span>
                              </div>
                              <div class="col-sm-8" style="padding-left: 15px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selABA"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.ABAHint"
                                    :max-length="50"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                              <div class="col-sm-4">
                                <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.SwiftCode}}</span>
                              </div>
                              <div class="col-sm-8" style="padding-left: 15px;">
                                <div class="value">
                                  <DxTextBox
                                    v-model="selSwiftCode"
                                    :placeholder="LangSelected.Externo.RegistroProveedor.SwiftCode"
                                    :max-length="50"
                                    :disabled=disabledAll
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-show="disabledAll==false">
                            <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin: 5px auto;text-align: right;">
                              <span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="guardarTabs()" :disabled=disabledAll>{{LangSelected.Externo.RegistroProveedor.BtnGuardarEnviar}}</span>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-horizontal" v-else-if="EstatusOverflow=='NoEncontrado'">
            <div style="padding: 10px;background: #55afff;color: #ffffff; text-align:center;">{{LangSelected.Externo.RegistroProveedor.msgInvitacionNoEncontrada}}</div>
          </div>
          <div class="form-horizontal" v-else-if="EstatusOverflow===null">
            <div style="padding: 20px; text-align: center; color: #888;">
              <i class="fa fa-spinner fa-spin" style="font-size: 24px;"></i>
              <p style="margin-top: 10px;">Cargando...</p>
            </div>
          </div>
          <div class="form-horizontal" v-else>
            <div style="padding: 10px;background: #55afff;color: #ffffff; text-align:center;">{{LangSelected.Externo.RegistroProveedor.msgProveedorRegistrado}}</div>
          </div>
        </div>
      </section>
      <b-modal id="modal-2" ref="modal-2" :title=HeaderDocumentosModal size="sl" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
        <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
          <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-12 span-label" style="padding-top: 0px;padding-right: 0px;" v-html="DocumentosHint"></span>
                  <div class="col-sm-12">
                    <div class="fileuploader-container"><!--:allowed-file-extensions="['.pdf']"-->
                      <DxFileUploader
                        class="docUploader"
                        id="fileUploaderContainerDOC"
                        :select-button-text="LangSelected.Externo.RegistroProveedor.tbArchivo"
                        label-text=""
                        upload-mode="uploadMode"
                        :ref="refDOCUploader"
                        :disabled=docDisabled
                        :onValueChanged="onBeforeSend"
                        @value-changed="e => docfiles = e.value"
                        style="text-align:center;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/apiClient';
//import md5 from 'js-md5';
import notify from'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
//import passwordMeter from "vue-simple-password-meter";
import { DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging} from 'devextreme-vue/data-grid';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxRadioGroup from 'devextreme-vue/radio-group';
import { DxFileUploader } from 'devextreme-vue/file-uploader';

import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';

export default {
  components:{
    DxLoadPanel,
    DxSelectBox,
    DxTextBox,
    DxRadioGroup,
    DxDataGrid, 
    DxColumn, 
    DxColumnChooser, 
    DxColumnFixing, 
    DxPager, 
    DxFilterRow, 
    DxPaging,
    DxFileUploader 
    //passwordMeter
  },
  data(){
    return{
      LangSelected:JSON.parse(localStorage.getItem('languageInfo')),
      languageSelected:localStorage.getItem('language'),
      loadingVisible: false,
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      showSecondBoxInfo:false,
      
      //?Datos generales
        JSONPais:[],/*[
          {Id_Pais:0,Pais:'<Seleccionar>'},
          {Id_Pais:1,Pais:'Mexico'},
          {Id_Pais:2,Pais:'Estado Unidos'},
          {Id_Pais:3,Pais:'Kanada'},
        ],*/
        selPais:0,
        searchModeOption: 'contains',
        searchExprOption: 'Pais',
        selRFC:null,
        selArchivosArray:[],
        selComercial:null,
        selRazonSocial:null,
        selId_GrupoCompras:null,
        TipoEmpresaEntities: [
          { id: 1, text: JSON.parse(localStorage.getItem('languageInfo')).Externo.RegistroProveedor.PersonaMoral },
          { id: 2, text: JSON.parse(localStorage.getItem('languageInfo')).Externo.RegistroProveedor.PersonaFisica }
        ],
        TipoEmpresa: 1,
        Id_ProveedoresSolicitudNuevoProv:null,
        Biblioteca:null,
        Carpeta:null,
        SitioSharepoint:null,
        showUploadProgress:false,
        uploadProgress:0,
        uploadBytes:{},
        showDownloadProgress:false,
        downloadProgress:0,
        selDias:"30",
        selContacto:null,
        selTipoEmpresa:1,
        selIdProveedor:21,
        tabIndex: 1,
      //?Documentacion
        JSONDocumentos:[],
        gridDocumentacion: 'gridDocumentacion',
        Id_CurrentDocument:null,
        HeaderDocumentosModal:'',
        DocumentosHint:'',
        refDOCUploader: 'refDOCUploader',
        docDisabled: false,
        disabledAll: false,
        EstatusOverflow: null,
        docfiles: [],
        arrayDocuments:[],
        doc_status:0,
        getFunctionData:[],
      //?Direccion
        selCalle:null,
        selColonia:null,
        selCP:null,
        selCiudad:null,
        selEstado:null,
      //?Datos Contacto
        selNombres:null,
        selApellidos:null,
        selApellidosM:null,
        selPuesto:null,
        selCorreo:null,
        selTelefono:null,
        selDireccion:null,
      //?Cuenta Bancaria
        JSONMonedas:[],
        selMoneda:null,
        searchModeOptionMon: 'contains',
        searchExprOptionMon: 'Moneda',
        selBanco:null,
        selNumeroCuenta:null,
        selTitularCuenta:null,
        selABA:null,
        selSwiftCode:null
    }
  },
  created: function(){
    if(this.$route.params.token){
      var that = this;
      apiClient.post('/api/Proveedores/DatosDeRegistroProveedor', { Token: that.$route.params.token, FormatoXML: false })
      .then(function (response) {
        var moduloss = response.data[0];
        console.log(moduloss);

        if (!moduloss) {
          that.EstatusOverflow = 'NoEncontrado';
          return;
        }

        apiClient.get('/api/Proveedores/Paises', { params: { Todos: 0, FormatoXML: false, token: that.$route.params.token } })
        .then(function (response) {
          var modulos = response.data;
          console.log(modulos);
          that.JSONPais = modulos;
          that.selPais=(moduloss.Id_Pais)?moduloss.Id_Pais:modulos[0].Selected;
          that.Id_ProveedoresSolicitudNuevoProv = moduloss.Id_ProveedoresSolicitudNuevoProv;
          that.TipoEmpresa = parseInt(moduloss.Id_ProveedoresTipoEmpresa);
          that.selTipoEmpresa = parseInt(moduloss.Id_ProveedoresTipoEmpresa);
          that.Biblioteca = moduloss.BibliotecaSharepoint;
          that.Carpeta = moduloss.PathSharepointPaso;
          that.SitioSharepoint = moduloss.SitioSharepointPaso;
          that.selRFC = moduloss.RFC;
          that.selComercial =  moduloss.NombreComercial;
          that.selId_GrupoCompras =  moduloss.Id_GrupoCompras;
          that.selDias =  (moduloss.DiasPlazo>=0)?""+moduloss.DiasPlazo+"":"30";
          that.selRazonSocial = moduloss.RazonSocial;
          that.selNombres = moduloss.NombreContacto
          that.selApellidos = (moduloss.ApellidoContacto)?moduloss.ApellidoContacto:null;
          that.selApellidosM = (moduloss.ApellidoMaterno)?moduloss.ApellidoMaterno:null;
          that.selCorreo = moduloss.CorreoElectronico;
          that.selPuesto = moduloss.Puesto;
          that.selTelefono = moduloss.Telefono;
          that.disabledAll = (parseInt(moduloss.Id_EstatusWorkflow)==5)?false:true;
          that.EstatusOverflow = moduloss.Id_EstatusWorkflow;

          apiClient.get('/api/General/getMonedas', { params: { Todos: 0, FormatoXML: false, token: that.$route.params.token } })
          .then(function (response) {
            var modulo = response.data;
            that.JSONMonedas = modulo;
          })
          .catch(function (error) {
            notify(error, 'error')
            that.JSONMonedas = [];
          });
          apiClient.post('/api/Proveedores/DatosProveedorDocumentacion', { Id_Pais: that.selPais, Id_TipoEmpresa: that.selTipoEmpresa, Idioma: that.languageSelected, Token: that.$route.params.token, FormatoXML: false })
          .then(function (response) {
            var modulo = response.data;
            that.JSONDocumentos = modulo;
          })
          .catch(function (error) {
            notify(error, 'error')
            that.JSONDocumentos = [];
          });

        })
        .catch(function (error) {
          console.log('Error: ' + error);
          that.dataPais = [];
        });
      }).catch(function (error) {
        notify(error, 'warning')
      });
    }else{
      notify(that.LangSelected.Externo.RegistroProveedor.Notify.ErrorToken, 'error');
      that.$router.push({name:'Home'});
    }
  },
  name: 'RegistroProveedor',
  methods: {
    changeTipoEmpresa(e) {
      var that = this;
      this.TipoEmpresa = e.value;
      console.log(this.TipoEmpresa);
      that.getDatosProveedorDocumentacion(that.selPais, this.TipoEmpresa);
    },
    changePais(e) {
      var that = this;
      this.selPais = e.value;
      console.log(this.selPais);
      that.getDatosProveedorDocumentacion(this.selPais, that.TipoEmpresa);
    },
    changeMoneda(e) {
      this.selMoneda = e.value;
      console.log(this.selMoneda);
    },
    getDatosProveedorDocumentacion:function(Pais, TipoEmpresa){
      console.log(Pais, TipoEmpresa);
      var that = this;
      that.arrayDocuments=[];
      that.JSONDocumentos=[];
      that.doc_status=0;
      apiClient.post('/api/Proveedores/DatosProveedorDocumentacion', { Id_Pais: Pais, Id_TipoEmpresa: TipoEmpresa, Idioma: that.languageSelected, Token: that.$route.params.token, FormatoXML: false })
      .then(function (response) {
        var modulo = response.data;
        that.JSONDocumentos = modulo;
      })
      .catch(function (error) {
        notify(error, 'error')
        that.JSONDocumentos = [];
      });
    },
    findFunction:function(datos){
      var that = this;
      if(datos.indexOf("@click=")>=0){
        var splitLink = datos.split("@click="); splitLink = splitLink[1].split('"'); splitLink[1] = splitLink[1].replaceAll(")",""); splitLink = splitLink[1].split('('); if(splitLink[1]!=""){splitLink[1] = splitLink[1].split(",")}else{splitLink.pop();} //console.log(splitLink);
        that.getFunctionData = (splitLink.length>=2)?splitLink[1]:[];
        eval('that.'+splitLink[0]+"()");
      }
    },
    upFile:function(registro) {
      var that = this;
      console.log(registro);
      that.HeaderDocumentosModal = registro.data.Documento;
      that.DocumentosHint = registro.data.Descripcion;
      that.Id_CurrentDocument = registro.data.Id_ProveedorSolicitudDocumentacion;
    },
    onBeforeSend:function(){
      console.log('Se resetea el doc')
      var that = this;
      //var url;
      const datosDOCFile = that.$refs[that.refDOCUploader].instance;
      const datosDOC = that.$refs[that.gridDocumentacion].instance;
      if(that.docfiles.length){
        console.log(that.docfiles);

        var selectedFiledoc = that.docfiles[0];

        // Validación de tamaño: archivo vacío (falla al cargar) y máximo 10 MB.
        if(selectedFiledoc.size === 0){
          notify('El archivo está vacío (0 bytes). Selecciona un archivo válido.', 'error', 7000);
          that.docfiles=[];
          datosDOCFile.reset();
          return false;
        }
        if(selectedFiledoc.size > 10*1024*1024){
          notify('El archivo supera el tamaño máximo permitido de 10 MB.', 'error', 7000);
          that.docfiles=[];
          datosDOCFile.reset();
          return false;
        }

        var extensiondoc = selectedFiledoc.name.substr( (selectedFiledoc.name.lastIndexOf('.') +1) );
        var newNamedoc = selectedFiledoc.name.split('.').slice(0, -1).join('.');
        newNamedoc = newNamedoc.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
        newNamedoc=newNamedoc+'.'+extensiondoc;
        console.log(extensiondoc.toLowerCase());
        console.log(newNamedoc);
        if(extensiondoc.toLowerCase()=='pdf' || extensiondoc.toLowerCase()=='jpg' || extensiondoc.toLowerCase()=='png' || extensiondoc.toLowerCase()=='doc' || extensiondoc.toLowerCase()=='docx'){
          console.log(selectedFiledoc);
          var findit = that.arrayDocuments.filter(function (data) { return data.Id_Doc == that.Id_CurrentDocument; });

          var FindItInOther = that.arrayDocuments.filter(function (data) { return data.Document.name == selectedFiledoc.name });
          console.log(FindItInOther);

          if(FindItInOther.length>=1){
            if(FindItInOther[0].Id_Doc!=that.Id_CurrentDocument){
              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ArchivoExistente, 'warning', 7000);
              that.docfiles=[];
              datosDOCFile.reset();
              return false;
            }
          }

          var finditIndex = that.arrayDocuments.findIndex((obj => obj.Id_Doc == that.Id_CurrentDocument));
          if(findit.length>=1){
            that.arrayDocuments[finditIndex].Document=selectedFiledoc;
            that.arrayDocuments[finditIndex].NewName=newNamedoc;
          }else{
            that.arrayDocuments.push({Id_Doc:that.Id_CurrentDocument,Document:selectedFiledoc,NewName:newNamedoc});
          }
          console.log(that.arrayDocuments);


          
          ///var finditDoc = that.arrayDocuments.filter(function (data) { return data.Id_ProveedorSolicitudDocumentacion == that.Id_CurrentDocument; });
          var finditIndexDoc = that.JSONDocumentos.findIndex((obj => obj.Id_ProveedorSolicitudDocumentacion == that.Id_CurrentDocument));
          that.JSONDocumentos[finditIndexDoc].NombreDocumento = newNamedoc;
          //console.log(that.JSONDocumentos);

          //datosDOC.cellValue(that.Id_CurrentDocument,'NombreDocumento',newNamedoc);
          datosDOC.saveEditData();
          that.validarTabDocumentos();
          console.log(that.JSONDocumentos);
        }else{
          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ExtencionIncorrecta, 'error',7000);
          datosDOCFile.reset();
        }
      }
    },
    validarTabDocumentos:function(){
      var that = this;
      console.log(that.arrayDocuments.length+"=="+that.JSONDocumentos.length);
      if(that.arrayDocuments.length == that.JSONDocumentos.length){
        that.doc_status = 2;
      }else if(that.arrayDocuments.length<=0){
        that.doc_status = 0;
      }else{
        that.doc_status = 1;
      }
    },
    guardarTabs:function(){

      var that = this;
      that.loadingVisible = true;
      if(that.arrayDocuments.length == that.JSONDocumentos.length){
        if(that.selPais>=1){
          if(that.selRFC){
            if(that.selComercial){
              if(that.selRazonSocial){
                if(that.selDias>=0){
                  //if(that.selContacto){
                    if(that.selCalle){
                      if(that.selColonia){
                        if(that.selCP){
                          if(that.selCiudad){
                            if(that.selEstado){
                              if(that.selNombres){
                                if(that.selApellidos){
                                  if(that.selApellidosM){
                                    if(that.selPuesto){
                                      if(that.selCorreo){
                                        if(that.selTelefono){
                                          if(that.selDireccion){
                                            if(that.selMoneda){
                                              if(that.selBanco){
                                                if(that.selNumeroCuenta){
                                                  if(that.selTitularCuenta){
                                                    if(that.selABA){
                                                      if(that.selSwiftCode){
                                                        var formData;
                                                        that.selArchivosArray=[];
                                                        var pair;
                                                        var AllOk = true;
                                                        //?GUARDAR DOCUMENTACION
                                                        that.uploadBytes = {};
                                                        that.uploadProgress = 0;
                                                        that.showUploadProgress = true;
                                                        that.arrayDocuments.forEach(function( value ) {
                                                          var selectedFile = value.Document;
                                                          var extension = selectedFile.name.substr( (selectedFile.name.lastIndexOf('.') +1) );
                                                          var newName = selectedFile.name.split('.').slice(0, -1).join('.');
                                                          newName = newName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
                                                          newName=newName+'.'+extension;

                                                          formData = new FormData();
                                                          formData.append('NombreArchivo', newName);
                                                          formData.append('BibliotecaSharepoint', that.Biblioteca);
                                                          formData.append('PathSharepoint', that.Carpeta);
                                                          formData.append('SitioSharepoint', that.SitioSharepoint);
                                                          formData.append('ReemplazarArchivo', 'true');
                                                          formData.append('Token', that.$route.params.token);
                                                          formData.append('file', value.Document);
                                                          for (pair of formData.entries()) {
                                                            console.log(pair[0]+ ', ' + pair[1]);
                                                          }
                                                          console.log(value.Document);
                                                          console.log(formData);
                                                          var rutas = that.SitioSharepoint+that.Biblioteca+that.Carpeta+newName;
                                                          console.log(rutas);
                                                          apiClient.post('/api/SharePoint/subir-archivo', formData, {
                                                            headers: { 'Content-Type': undefined },
                                                            onUploadProgress: function (e) {
                                                              that.$set(that.uploadBytes, newName, { loaded: e.loaded, total: e.total || e.loaded });
                                                              var loaded = 0, total = 0;
                                                              Object.keys(that.uploadBytes).forEach(function (k) {
                                                                loaded += that.uploadBytes[k].loaded;
                                                                total += that.uploadBytes[k].total;
                                                              });
                                                              that.uploadProgress = total ? Math.round((loaded / total) * 100) : 0;
                                                            }
                                                          })
                                                          .then(function (response) {
                                                              console.log(response);
                                                              that.selArchivosArray.push({
                                                                Id_SolicitudDocumentacion:""+value.Id_Doc+"",
                                                                NombreArchivo:""+newName+"",
                                                                PathArchivo:""+rutas+""
                                                              });
                                                              var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                                                                             (response.data && response.data.ERROR=="False");
                                                              if(isSuccess){
                                                                console.log('Archivo guardado correctamente');
                                                                console.log({AllOk:AllOk,selArchivosArray:that.selArchivosArray.length,arrayDocuments:(that.arrayDocuments.length)});
                                                                if(AllOk==true && that.selArchivosArray.length == that.arrayDocuments.length){
                                                                  that.showUploadProgress = false;
                                                                  var Id_Pais = that.selPais;
                                                                  var RFC = that.selRFC.replace(/[/'"/g]/g, ""); //= escapeURI(that.selRFC,"e");
                                                                  var NombreComercial = that.selComercial.replace(/[/'"/g]/g, ""); //= escapeURI(that.selComercial,"e");
                                                                  var RazonSocial = that.selRazonSocial.replace(/[/'"/g]/g, ""); //= escapeURI(that.selRazonSocial,"e");
                                                                  var TipoEmpresa = that.TipoEmpresa;
                                                                  var DiasPlazo = that.selDias;
                                                                  var CalleYNumero = that.selCalle.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCalle,"e");
                                                                  var Colonia = that.selColonia.replace(/[/'"/g]/g, ""); //= escapeURI(that.selColonia,"e");
                                                                  var CP = that.selCP.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCP,"e");
                                                                  var Ciudad = that.selCiudad.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCiudad,"e");
                                                                  var Estado = that.selEstado.replace(/[/'"/g]/g, ""); //= escapeURI(that.selEstado,"e");
                                                                  var NombreContacto = that.selNombres.replace(/[/'"/g]/g, ""); //= escapeURI(that.selNombres,"e");
                                                                  var ApellidoContacto = that.selApellidos.replace(/[/'"/g]/g, ""); //= escapeURI(that.selApellidos,"e");
                                                                  var ApellidoMaternoContacto = that.selApellidosM.replace(/[/'"/g]/g, ""); //= escapeURI(that.selApellidosM,"e");
                                                                  var Puesto = that.selPuesto.replace(/[/'"/g]/g, ""); //= escapeURI(that.selPuesto,"e");
                                                                  ///var CorreoElectronico = that.selCorreo; //= escapeURI(that.selCorreo,"e");
                                                                  var Telefono = that.selTelefono; //= escapeURI(that.selTelefono,"e");
                                                                  var Direccion = that.selDireccion.replace(/[/'"/g]/g, ""); //= escapeURI(that.selDireccion,"e");
                                                                  var Moneda = that.selMoneda.replace(/[/'"/g]/g, ""); //= escapeURI(that.selMoneda,"e");
                                                                  var Banco = that.selBanco.replace(/[/'"/g]/g, ""); //= escapeURI(that.selBanco,"e");
                                                                  var NumeroCuenta = that.selNumeroCuenta.replace(/[/'"/g]/g, ""); //= escapeURI(that.selNumeroCuenta,"e");
                                                                  var TitularCuenta = that.selTitularCuenta.replace(/[/'"/g]/g, ""); //= escapeURI(that.selTitularCuenta,"e");
                                                                  var ABA = that.selABA.replace(/[/'"/g]/g, ""); //= escapeURI(that.selABA,"e");
                                                                  var SwiftCode = that.selSwiftCode.replace(/[/'"/g]/g, ""); //= escapeURI(that.selSwiftCode,"e");
                                                                  console.log(that.selArchivosArray);
                                                                  var languageSelected = (that.languageSelected)?that.languageSelected:"ES";

                                                                  that.sp_prv_updDatosProveedor_XML(""+that.$route.params.token+"", Id_Pais, ""+RFC+"", ""+NombreComercial+"", ""+RazonSocial+"", TipoEmpresa, DiasPlazo, ""+CalleYNumero+"", ""+Colonia+"", ""+Ciudad+"", ""+Estado+"", ""+NombreContacto+"", ""+ApellidoContacto+"", ""+ApellidoMaternoContacto+"", ""+Puesto+"", ""+Telefono+"", ""+Direccion+"", ""+Moneda+"", ""+Banco+"", ""+NumeroCuenta+"", ""+TitularCuenta+"", ""+ABA+"", ""+SwiftCode+"", ""+CP+"", ""+languageSelected+"");
                                                                } 
                                                              }else{
                                                                that.loadingVisible = false;
                                                                that.showUploadProgress = false;
                                                                console.log('Ocurrio un error inesperado contacte al administrador "'+response.data.ERROR + ' ' + response.data.MSN+' Line:1221"');
                                                                notify(that.LangSelected.Externo.RegistroProveedor.Notify.ErrorPeticion, 'error', 15000);
                                                                AllOk=false;
                                                              }
                                                          })
                                                          .catch(function (response) {
                                                            //handle error
                                                              AllOk=false;
                                                              console.log(response);
                                                              that.loadingVisible = false;
                                                              that.showUploadProgress = false;
                                                              console.log('Error al guardar xml: msg->' + response.data.MSN);
                                                              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ErrorPeticion, 'error', 10000);
                                                          });
                                                        });
                                                      }else{
                                                        that.loadingVisible = false;
                                                        notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionSwiftCode, 'error');
                                                      }
                                                    }else{
                                                      that.loadingVisible = false;
                                                      notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionABA, 'error');
                                                    }
                                                  }else{
                                                    that.loadingVisible = false;
                                                    notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionTitular, 'error');
                                                  }
                                                }else{
                                                  that.loadingVisible = false;
                                                  notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionNoCuenta, 'error');
                                                }
                                              }else{
                                                that.loadingVisible = false;
                                                notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionBanco, 'error');
                                              }
                                            }else{
                                              that.loadingVisible = false;
                                              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionMoneda, 'error');
                                            }
                                          }else{
                                            that.loadingVisible = false;
                                            notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionDireccion, 'error');
                                          }
                                        }else{
                                          that.loadingVisible = false;
                                          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionTelefono, 'error');
                                        }
                                      }else{
                                        that.loadingVisible = false;
                                        notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionCorreo, 'error');
                                      }
                                    }else{
                                      that.loadingVisible = false;
                                      notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionPuesto, 'error');
                                    }
                                  }else{
                                    that.loadingVisible = false;
                                    notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionApellidoM, 'error');
                                  }
                                }else{
                                  that.loadingVisible = false;
                                  notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionApellidoP, 'error');
                                }
                              }else{
                                that.loadingVisible = false;
                                notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionNombres, 'error');
                              }
                            }else{
                              that.loadingVisible = false;
                              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionEstado, 'error');
                            }
                          }else{
                            that.loadingVisible = false;
                            notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionCiudad, 'error');
                          }
                        }else{
                          that.loadingVisible = false;
                          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionCP, 'error');
                        }
                      }else{
                        that.loadingVisible = false;
                        notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionColonia, 'error');
                      }
                    }else{
                      that.loadingVisible = false;
                      notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionCalleNumero, 'error');
                    }
                  //}else{
                    //notify('Favor de introducir el contacto en Arendal.', 'error');
                  //}
                }else{
                  that.loadingVisible = false;
                  notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionDiasPlazo, 'error');
                }
              }else{
                that.loadingVisible = false;
                notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionRazonSocial, 'error');
              }
            }else{
              that.loadingVisible = false;
              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionNomComercial, 'error');
            }
          }else{
            that.loadingVisible = false;
            notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionRFC, 'error');
          }
        }else{
          that.loadingVisible = false;
          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionPais, 'error');
        }
      }else{
        that.loadingVisible = false;
        notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionDocumentos, 'error');
      }
    },
    sp_prv_updDatosProveedor_XML(Token, Id_Pais, RFC, NombreComercial, RazonSocial, TipoEmpresa, DiasPlazo, CalleYNumero, Colonia, Ciudad, Estado, NombreContacto, ApellidoContacto, ApellidoMaternoContacto, Puesto, Telefono, Direccion, Moneda, Banco, NumeroCuenta, TitularCuenta, ABA, SwiftCode, CP, languageSelected){
      var that = this;
      apiClient.put('/api/Proveedores/updDatosProveedor', {
        Token: Token,
        Id_Pais: Id_Pais,
        RFC: RFC,
        NombreComercial: NombreComercial,
        RazonSocial: RazonSocial,
        TipoEmpresa: TipoEmpresa,
        DiasPlazo: DiasPlazo,
        CalleYNumero: CalleYNumero,
        Colonia: Colonia,
        Ciudad: Ciudad,
        Estado: Estado,
        NombreContacto: NombreContacto,
        ApellidoContacto: ApellidoContacto,
        ApellidoMaternoContacto: ApellidoMaternoContacto,
        Puesto: Puesto,
        Telefono: Telefono,
        Direccion: Direccion,
        Moneda: Moneda,
        Banco: Banco,
        NumeroCuenta: NumeroCuenta,
        TitularCuenta: TitularCuenta,
        ABA: ABA,
        SwiftCode: SwiftCode,
        CodigoPostal: CP,
        Idioma: languageSelected,
        Archivos: that.selArchivosArray,
        FormatoXML: false
      }, { withLenguaje: true })
      .then(function (response) {
        console.log(response);
        if(response.data[0].Estatus=="ERROR"){
          notify(response.data[0].Mensaje, 'error', 15000);
        }else if(response.data[0].Estatus=="OK"){
          that.disabledAll = true;
          notify(response.data[0].Mensaje, 'success', 15000);
        }else{
          notify(response.data[0].Mensaje, 'error', 15000);
        }
        that.loadingVisible = false;
      })
      .catch(function (error) {
        console.log(error);
        that.loadingVisible = false;
      });
    },
    functionDescarga:function(){
      //solo se puede poner una @click por registro
      //ejemplo:
      //<a style="color:#007bff;" @click="functionName(variable 1,te la comes)">
      //no poner commillas (") dentro de la funcion

      console.log(""+ this.$route.params.token + "")
      console.log(this.getFunctionData[0]);//Obtiene las variables dentro de la funcion (variable1,variable2,variable3,...)

      var that = this;
      that.downloadProgress = 0;
      that.showDownloadProgress = true;
      apiClient.get('/api/SharePoint/descargar-documento', {
        responseType: 'blob',
        onDownloadProgress: function (e) {
          if (e.total) {
            that.downloadProgress = Math.round((e.loaded / e.total) * 100);
          }
        },
        params: {
          SitioSharepoint: 'https://arendalgo.sharepoint.com/sites/'+this.getFunctionData[2],
          BibliotecaSharepoint: 'Documentos',
          PathSharepoint: this.getFunctionData[3],
          NombreArchivo: this.getFunctionData[0],
          Token: this.$route.params.token
        }
      })
        .then(function (response) {
          console.log(response);
          var blob = new Blob([response.data]);
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = that.getFunctionData[0];
          link.click();
          that.showDownloadProgress = false;
        })
        .catch(function (error) {
          console.log('Error al descargar:', error);
          notify('Error al descargar el archivo', 'error');
          that.showDownloadProgress = false;
        });






    }
  },
  watch: {

  }
}
</script>

<style scoped>
/* Overlay de progreso de carga/descarga (centrado) */
.cc-progress-overlay{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.cc-progress-card{
  background: #fff;
  border-radius: 14px;
  padding: 26px 34px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
  min-width: 340px;
  max-width: 90%;
  text-align: center;
}
.cc-progress-label{
  margin: 0 0 14px;
  font-size: 15px;
  color: #333;
}
.cc-progress-track{
  height: 24px;
  border-radius: 50px;
  background: #e9ecef;
  overflow: hidden;
  border: 1px solid #d0d4d9;
}
.cc-progress-fill{
  height: 100%;
  border-radius: 50px;
  min-width: 6%;
  background-image: repeating-linear-gradient(45deg,#34c759 0,#34c759 12px,#2faa4d 12px,#2faa4d 24px);
  background-size: 48px 48px;
  animation: cc-stripes 1s linear infinite;
  transition: width .25s ease;
}
@keyframes cc-stripes{
  from{ background-position: 0 0; }
  to{ background-position: 48px 0; }
}

a{
  color: #313538 !important;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
.span-label{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.dx-datagrid-headers{
  font-weight: bold;
}
.selector_action{
  height: 24px;
  padding: 0px 0px;
}
.DxDataGrid-txtbold{
  text-decoration: underline;
  color: rgb(60, 142, 190, 0.9) !important;
  font-weight: 700;
  cursor: pointer;
}
.btnSimple{
  background: rgb(60, 142, 190, 0.9) !important;
}
.box{
  box-shadow:none;
}
.checkboxTextStile{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
}
.inputError{
  border: solid thin #ff000070;
}
.inputOk{
  border: solid thin #00800082;
}

.nav-link{
  display: block;
  padding: 0px !important;
}

.button-span-uploaded{
  color: white !important;
  padding: 3px 25% 3px 25%;
  border-color: #028002 !important;
  background: #459745 !important;
}
.color-upladed{
  color: #459745 !important;
}
.button-p-subir{
  white-space: initial;
  font-weight: 400;
  font-size: 10px;
  font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;
  margin: 0px 0px -10px 0px;
  border: solid thin #028002;
  border-radius: 5px 5px 0px 0px;
  background: #d1f9d1;
  cursor: pointer;
  padding: 0px 5px 10px 5px;
  overflow: hidden;
}
</style> 
